<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important;"
  >
    <PageHeader pageTitle="Panorama" style="padding-top: 1rem;">
      <div style="display: flex; gap: 0.5rem;">
        <GenericSearchInput v-model="search.textSearch" />
        <SelectPanoramaInstallationStatus v-model="search.installationStatus" />
        <SelectPromoter
          v-if="panoramaList.length"
          :traderList="traderList"
          v-model="search.trader"
        />
        <SelectBillingStatus v-model="search.billingStatus" />
        <SelectYear v-model="search.year" />
        <SelectAccountManager v-model="search.accountManagerId" />
      </div>
    </PageHeader>

    <b-skeleton-table
      animation="wave"
      style="margin-top: 2rem;"
      :rows="5"
      :columns="15"
      :table-props="{ bordered: true, striped: true }"
      v-if="isLoading"
    />

    <section
      v-if="this.panoramaStatusSummaryList && !isLoading"
      style="margin-botton: 2rem;"
    >
      <PanoramaSummaryTable
        :panoramaStatusSummaryList="panoramaStatusSummaryList"
      />
    </section>

    <section
      class="d-flex justify-content-between flex-column"
      style="margin-top: 2rem; height: 60%;"
      v-if="!isLoading && panoramaList.length"
    >
      <Table class="panorama-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(panoramaCol, index) of panoramaColumns"
              :key="`${panoramaCol.name}_${index}`"
            >
              <ColumnHeader
                :sort="panoramaCol.sort"
                :somatory="panoramaCol.somatory"
                :columnName="panoramaCol.name"
                :columnKey="panoramaCol.key"
                :columnType="panoramaCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="panoramaList"
                v-on:sortListByKey="sortListByKey(panoramaCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow
            v-for="(panorama, index) of panoramaList"
            :key="`${panorama.name}_${index}`"
          >
            <TableCell>
              {{ panorama.installationNumber }}
            </TableCell>
            <TableCell>
              <RenderNameColumnValue :name="panorama.name" />
            </TableCell>
            <TableCell
              :style="setInstallationStatusColor(panorama.installationStatus)"
            >
              {{ translateInstallationStatus(panorama.installationStatus) }}
            </TableCell>
            <TableCell class="money-cell">
              <RenderMoneyColumnValue :value="panorama.totalValue" />
            </TableCell>
            <TableCell class="money-cell">
              <div v-if="panorama.qtyOverdueInvoice">
                {{ panorama.qtyOverdueInvoice }} |
                <RenderMoneyColumnValue
                  :value="panorama.totalOverdueInvoiceValue"
                />
              </div>
            </TableCell>
            <TableCell
              class="money-cell"
              style="border-left: 2px solid gray !important;"
            >
              <RenderPanoramaInvoiceLine
                v-if="panorama.janInvoiceData"
                :invoice-value="panorama.janInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.janInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.febInvoiceData"
                :invoice-value="panorama.febInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.febInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.marInvoiceData"
                :invoice-value="panorama.marInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.marInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.aprInvoiceData"
                :invoice-value="panorama.aprInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.aprInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.mayInvoiceData"
                :invoice-value="panorama.mayInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.mayInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.junInvoiceData"
                :invoice-value="panorama.junInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.junInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.julInvoiceData"
                :invoice-value="panorama.julInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.julInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.augInvoiceData"
                :invoice-value="panorama.augInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.augInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.sepInvoiceData"
                :invoice-value="panorama.sepInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.sepInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.octInvoiceData"
                :invoice-value="panorama.octInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.octInvoiceData.status"
              />
            </TableCell>
            <TableCell class="money-cell">
              <RenderPanoramaInvoiceLine
                v-if="panorama.novInvoiceData"
                :invoice-value="panorama.novInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.novInvoiceData.status"
              />
            </TableCell>
            <TableCell
              class="money-cell"
              style="border-right: 2px solid gray; !important"
            >
              <RenderPanoramaInvoiceLine
                v-if="panorama.decInvoiceData"
                :invoice-value="panorama.decInvoiceData.boletoVeins"
                :panorama-invoice-status="panorama.decInvoiceData.status"
              />
            </TableCell>
            <TableCell
              class="money-cell"
              :style="{
                color: defineQtyDaysInStatusColor(panorama.qtyDaysInStatus),
              }"
            >
              {{ panorama.qtyDaysInStatus }}
            </TableCell>
            <TableCell class="money-cell">
              <RenderDateColumnValue
                formatType="DD"
                :value="panorama.dueDate"
              />
            </TableCell>
            <TableCell>
              <RenderSocialNumberColumnValue
                :social-number="panorama.socialNumber"
              />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue
                v-if="panorama.traderName"
                :name="panorama.traderName"
              />
            </TableCell>
            <TableCell>
              <RenderNameColumnValue
                v-if="panorama.accountManagerName"
                :name="panorama.accountManagerName"
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </section>
    <empty-list v-else-if="!isLoading" />
  </main>
</template>

<script>
import {
  PanoramaSummaryTable,
  RenderPanoramaInvoiceLine,
  SelectPanoramaInstallationStatus,
} from '../../modules/panorama/components';
import { SelectBillingStatus } from '../../modules/invoice/components';
import {
  SelectYear,
  SelectPromoter,
  SelectAccountManager,
} from '../../ui/selects';
import { GenericSearchInput } from '../../ui/inputs';
import { PageHeader } from '../../ui/page-header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import { ColumnHeader } from '../../ui/column-header';
import { Api } from '../../vue/api';
import helpers from '../../vue/helpers';
import {
  RenderDateColumnValue,
  RenderMoneyColumnValue,
  RenderNameColumnValue,
  RenderSocialNumberColumnValue,
} from '../../ui/render';
import { INSTALLATION_STATUS_IN_PTBR } from '../../modules/installation/constants';
import { PANORAMA_INVOICE_STATUS } from '../../modules/panorama/constants';
import { defineArrowDirection, sortByProperty } from '../../utils';
import {
  sortPanoramaInvoiceByBoletoVeins,
  setPanoramaInvoiceInstallationStatusColor,
} from '../../modules/panorama/utils';
const API = new Api();

/**
 * @typedef {Object} InvoiceData
 * @property {number} boletoVeins
 * @property {string} status
 */

/**
 * Objeto que representa as Faturas de cada Instalção para a construção da tabela de Panorama
 * @typedef {Object} PanoramaInvoice
 * @property {number} id
 * @property {number} installationNumber
 * @property {string} name
 * @property {"CONNECTING" | "ACTIVE" | "INACTIVATION_REQUESTED" | "DISCONNECTED" | "DEBT" | "INACTIVE" | "SETTLEMENT" | "WRONG_OWNER"} installationStatus
 * @property {number} totalValue
 * @property {number} qtyOverdueInvoice
 * @property {number} totalOverdueInvoiceValue
 * @property {InvoiceData | null} janInvoiceData
 * @property {InvoiceData | null} febInvoiceData
 * @property {InvoiceData | null} marInvoiceData
 * @property {InvoiceData | null} aprInvoiceData
 * @property {InvoiceData | null} mayInvoiceData
 * @property {InvoiceData | null} junInvoiceData
 * @property {InvoiceData | null} julInvoiceData
 * @property {InvoiceData | null} augInvoiceData
 * @property {InvoiceData | null} sepInvoiceData
 * @property {InvoiceData | null} octInvoiceData
 * @property {InvoiceData | null} novInvoiceData
 * @property {InvoiceData | null} decInvoiceData
 * @property {number} qtyDaysInStatus
 * @property {string} dueDate
 * @property {string} socialNumber
 * @property {string} traderName
 * @property {string} accountManagerName
 */

/**
 * @typedef {Object} PanoramaStatusSummary
 * @property {string} name
 * @property {number} total
 * @property {number} subtotal
 * @property {InvoiceData[] | null} january
 * @property {InvoiceData[] | null} february
 * @property {InvoiceData[] | null} march
 * @property {InvoiceData[] | null} april
 * @property {InvoiceData[] | null} may
 * @property {InvoiceData[] | null} june
 * @property {InvoiceData[] | null} july
 * @property {InvoiceData[] | null} august
 * @property {InvoiceData[] | null} september
 * @property {InvoiceData[] | null} october
 * @property {InvoiceData[] | null} november
 * @property {InvoiceData[] | null} december
 */

export default {
  components: {
    SelectPanoramaInstallationStatus,
    SelectBillingStatus,
    GenericSearchInput,
    SelectPromoter,
    SelectYear,
    PageHeader,
    PanoramaSummaryTable,
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    ColumnHeader,
    TableCell,
    RenderNameColumnValue,
    RenderMoneyColumnValue,
    RenderDateColumnValue,
    RenderSocialNumberColumnValue,
    RenderPanoramaInvoiceLine,
    SelectAccountManager,
  },
  data() {
    return {
      isLoading: false,
      search: {
        textSearch: null,
        installationStatus: null,
        trader: null,
        billingStatus: null,
        year: '2024',
        accountManagerId: null,
      },
      traderList: [],
      /**
       * Lista de faturas das instalações com dados preservados da consulta a API
       * @type {PanoramaInvoice[]}
       */
      panoramaList: [],
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      panoramaColumns: [
        {
          name: 'Instalação',
          key: 'installationNumber',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Nome',
          key: 'name',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Status',
          key: 'status',
          columnType: '(QTY)',
          sort: false,
          somatory: true,
        },
        {
          name: 'Total',
          key: 'totalValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Atrasadas',
          key: 'totalOverdueInvoiceValue',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Janeiro',
          key: 'janInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Fevereiro',
          key: 'febInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Março',
          key: 'marInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Abril',
          key: 'aprInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Maio',
          key: 'mayInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Junho',
          key: 'junInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Julho',
          key: 'julInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Agosto',
          key: 'augInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Setembro',
          key: 'sepInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Outubro',
          key: 'octInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Novembro',
          key: 'novInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Dezembro',
          key: 'decInvoiceData',
          columnType: '(R$)',
          sort: true,
          somatory: true,
        },
        {
          name: 'Dias',
          key: 'qtyDaysInStatus',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'Vence',
          key: 'dueDay',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'CPF/CNPJ',
          key: 'socialNumber',
          columnType: '',
          sort: false,
          somatory: false,
        },
        {
          name: 'Promotor',
          key: 'traderName',
          columnType: '',
          sort: true,
          somatory: false,
        },
        {
          name: 'CS',
          key: 'accountManagerName',
          columnType: '',
          sort: true,
          somatory: false,
        },
      ],
      /**
       * Lista com o resumo de faturas por status
       * @type {PanoramaStatusSummary[]}
       */
      panoramaStatusSummaryList: [],
    };
  },
  async mounted() {
    this.$router.push({
      query: {
        year: this.search.year,
      },
    });
    await this.getAll();
  },
  computed: {
    trader() {
      return this.search.trader;
    },
    installationStatus() {
      return this.search.installationStatus;
    },
    billingStatus() {
      return this.search.billingStatus;
    },
    year() {
      return this.search.year;
    },
    textSearch() {
      return this.search.textSearch;
    },
    accountManagerId() {
      return this.search.accountManagerId;
    },
  },
  watch: {
    trader() {
      this.handleFilterList('trader', 'trader');
    },
    textSearch() {
      this.handleFilterList('search', 'textSearch');
    },
    installationStatus() {
      this.handleFilterList('status', 'installationStatus');
    },
    billingStatus() {
      this.handleFilterList('billingStatus', 'billingStatus');
    },
    year() {
      this.handleFilterList('year', 'year');
    },
    accountManagerId() {
      this.handleFilterList('accountManagerId', 'accountManagerId');
    },
  },
  methods: {
    async getAll() {
      this.isLoading = true;
      const result = await API.post('/execute', {
        path:
          '/current-installations' + helpers.toQueryString(this.$route.query),
        method: 'get',
      });
      const traderList = [];
      for (const panoramaInvoice of result.model.panoramaList) {
        if (panoramaInvoice.traderName) {
          traderList.push(panoramaInvoice.traderName);
        }
      }
      this.traderList = traderList;
      this.panoramaList = result.model.panoramaList;
      this.panoramaStatusSummaryList = this.createStatusSummaryPanoramaList(
        result.model.panoramaList,
      );
      this.isLoading = false;
    },
    /**
     * Transforma a lista de panorama em uma lista de resumo de status
     * @param {PanoramaInvoice[]} panoramaList
     * @returns {PanoramaStatusSummary[]}
     */
    createStatusSummaryPanoramaList(panoramaList) {
      const statusMap = new Map();

      for (const invoiceStatus of Object.keys(PANORAMA_INVOICE_STATUS)) {
        statusMap.set(invoiceStatus, {
          name: PANORAMA_INVOICE_STATUS[invoiceStatus],
          total: 0,
          subtotal: 0,
          qtyInvoceInStatus: 0,
          percentageOfTotal: 0,
          january: [],
          february: [],
          march: [],
          april: [],
          may: [],
          june: [],
          july: [],
          august: [],
          september: [],
          october: [],
          november: [],
          december: [],
        });
      }

      const monthMap = {
        jan: 'january',
        feb: 'february',
        mar: 'march',
        apr: 'april',
        may: 'may',
        jun: 'june',
        jul: 'july',
        aug: 'august',
        sep: 'september',
        oct: 'october',
        nov: 'november',
        dec: 'december',
      };

      panoramaList.forEach(installation => {
        Object.keys(installation).forEach(key => {
          if (key.endsWith('InvoiceData') && installation[key]) {
            const { boletoVeins, status } = installation[key];

            const statusSummary = statusMap.get(status);
            const totalStatus = statusMap.get('TOTAL');
            statusSummary.total += boletoVeins;
            statusSummary.subtotal += boletoVeins;
            statusSummary.qtyInvoceInStatus += 1;
            totalStatus.total += boletoVeins;
            totalStatus.subtotal += boletoVeins;
            totalStatus.qtyInvoceInStatus += 1;

            const abbreviatedMonth = key.slice(0, 3).toLowerCase();
            const month = monthMap[abbreviatedMonth];
            statusSummary[month].push({ boletoVeins, status });
            totalStatus[month].push({ boletoVeins, status });
          }
        });
      });

      const totalOverall = statusMap.get('TOTAL').total;

      statusMap.forEach((statusSummary, status) => {
        statusSummary.percentageOfTotal =
          (statusSummary.total / totalOverall) * 100;

        const months = [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december',
        ];
        months.forEach(month => {
          statusSummary[month] = statusSummary[month].map(entry => ({
            ...entry,
            percentageOfTotal: (entry.boletoVeins / statusSummary.total) * 100,
          }));
        });
      });

      return Array.from(statusMap.values());
    },
    translateInstallationStatus(status) {
      const translatedStatus = INSTALLATION_STATUS_IN_PTBR[status];
      return translatedStatus.length > 10
        ? `${translatedStatus.substring(0, 10)}...`
        : translatedStatus;
    },
    /**
     * Método para filtrar a lista
     * @return {function(): void}
     */
    async handleFilterList(queryProp, searchProp) {
      this.$route.query[queryProp] = this.search[searchProp];
      await this.getAll();
    },
    defineQtyDaysInStatusColor(qtyDaysInStatus) {
      qtyDaysInStatus = Math.ceil(qtyDaysInStatus);
      if (qtyDaysInStatus > 30 && qtyDaysInStatus <= 45) {
        return '#EBE76C';
      } else if (qtyDaysInStatus > 45 && qtyDaysInStatus <= 60) {
        return '#FFB000';
      } else if (qtyDaysInStatus > 60) {
        return '#F24C3D';
      } else {
        return '';
      }
    },
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection,
      );
      this.currentColumnFiltered = columnKey;
      if (
        [
          'janInvoiceData',
          'febInvoiceData',
          'marInvoiceData',
          'aprInvoiceData',
          'mayInvoiceData',
          'junInvoiceData',
          'julInvoiceData',
          'augInvoiceData',
          'sepInvoiceData',
          'octInvoiceData',
          'novInvoiceData',
          'decInvoiceData',
        ].includes(columnKey)
      ) {
        sortPanoramaInvoiceByBoletoVeins(
          this.panoramaList,
          columnKey,
          this.sortDirection === 'ASC',
        );
        return;
      }
      sortByProperty(this.panoramaList, columnKey, this.sortDirection);
    },
    setInstallationStatusColor(status) {
      return setPanoramaInvoiceInstallationStatusColor(status);
    },
  },
};
</script>

<style lang="scss" scoped>
.panorama-table {
  display: block;
  max-height: 88vh !important;
  height: auto !important;
  margin-top: 1rem;

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    position: sticky;
    left: 5.5rem;
    background-color: #e7e7e7;
    min-width: 280px;
  }

  td:nth-child(3),
  th:nth-child(3) {
    position: sticky;
    left: 23rem;
    background-color: #e7e7e7;
    min-width: 112px;
  }

  td:nth-child(4),
  th:nth-child(4) {
    position: sticky;
    left: 30rem;
    background-color: #e7e7e7;
  }

  td:nth-child(5),
  th:nth-child(5) {
    position: sticky;
    min-width: 100px;
    left: 34.5rem;
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 5) {
    background-color: #e7e7e7;
  }

  tr:nth-child(even) td:nth-child(-n + 5) {
    background-color: #f2f2f2;
  }
}

.panorama-table .money-cell {
  text-align: right;
}
</style>
